import React from 'react';
import { Spin } from 'antd';
import PropTypes from 'prop-types';
import { useTheme } from '../../contexts/ThemeContext';

const Loading = ({ 
  size = 'default',
  tip = 'Carregando...',
  style,
  className,
  ...props 
}) => {
  const { theme } = useTheme();

  const loadingStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
    color: theme.primary,
    ...style,
  };

  return (
    <div className={className} style={loadingStyle}>
      <Spin size={size} tip={tip} {...props} />
    </div>
  );
};

Loading.propTypes = {
  size: PropTypes.oneOf(['small', 'default', 'large']),
  tip: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default Loading; 